<template>
    <div>
        <span v-text="value"  v-if="!isEdit" :class="classes" @dblclick="toggle"></span>
        <select v-model="value"
                v-if="isEdit"
                class="custom-select-sm"
                @change="onChange"
                @blur="onBlur"
                autofocus
        >
            <option v-for="item in dataset"
                    :value="item"
                    v-text="item"
                    :selected="data == item ? true : false"
            >

            </option>
        </select>
    </div>
</template>

<script>
    import EditCell from "../../mixins/EditCell";

    export default {

        mixins: [EditCell],

        props: ['dataset']
    }
</script>